import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useOrderAPI() {
  const { userRef, spotRef, menuIdRef, languageRef } = useStorage();

  function loadOrderFromRemote(id) {
    const url = `/vbeta2/menu/orders/${id}`;

    return axios({
      url,
      method: 'get',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Accept-Language': languageRef.current?.tag,
        'Menu-Id': menuIdRef.current,
      },
      responseType: 'json',
    });
  }

  function findSpotOrdersFromRemote() {
    const url = `/vbeta2/menu/orders`;

    const params = {};
    if (spotRef.current?.id != null) {
      params.spot_id = `${spotRef.current.id}`;
      params.lang = languageRef.current?.tag;
    }

    const headers = {
      'Menu-Id': menuIdRef.current,
      'Accept-Language': languageRef.current?.tag,
    };

    if (userRef?.current?.token != null) {
      headers.Authorization = `Bearer ${userRef.current.token}`;
    }

    return axios({
      url,
      method: 'get',
      params,
      headers,
      responseType: 'json',
    });
  }

  function findPaymentOrdersFromRemote(payment) {
    const url = `/vbeta2/menu/orders`;

    const headers = {
      'Menu-Id': menuIdRef.current,
      'Accept-Language': languageRef.current?.tag,
    };

    if (userRef?.current?.token != null) {
      headers.Authorization = `Bearer ${userRef.current.token}`;
    }

    return axios({
      url,
      params: {
        payment_id: payment.id,
        lang: languageRef.current?.tag,
      },
      method: 'get',
      headers,
      responseType: 'json',
    });
  }

  function submitOrderFromRemote(order) {
    const url = `/vbeta2/orders`;

    return axios({
      url,
      method: 'post',
      data: order,
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Content-Type': 'application/json',
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function cancelOrderFromRemote(id) {
    const url = `/vbeta2/orders/${id}/cancel`;

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    loadOrderFromRemote,
    findSpotOrdersFromRemote,
    findPaymentOrdersFromRemote,
    submitOrderFromRemote,
    // submitOrderFromRemoteOLD,
    // findSpotOrdersFromRemoteOLD,
    // getOrderFromRemote,
    cancelOrderFromRemote,
  };
}

export { useOrderAPI };
